import {itemWithoutCombinedListing} from './itemWithoutCombinedListing';

export const query = `query getFilteredProductsWithoutCombinedListing($mainCollectionId: String!, $filters: ProductFilters, $sort: ProductSort, $offset: Int, $limit: Int, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
  catalog {
    category(categoryId: $mainCollectionId) {
      productsWithMetaData(filters: $filters, limit: $limit, sort: $sort, offset: $offset, onlyVisible: true) {
        totalCount
        list {
           ${itemWithoutCombinedListing}
        }
      }
    }
  }
}
`;
